import { relevant } from '../../api';
import classes from '../../api/classes';
import { stores } from '../../stores';
import SystemData from '../../lib/systemData';

const aiApiCall = (fnName, params) => {
	const isAbsoluteUrl = relevant.baseUrl.startsWith('http');
	const apiUrl = isAbsoluteUrl ? relevant.baseUrl : `${window.location.origin}${relevant.baseUrl}`;

	return classes.MiscTasks[fnName]({
		...params,
		apiEndpoint: SystemData.genericData.aiEndpoint,
		aiCallData: {
			id: stores.identity.userId(),
			host: apiUrl.replace(/\/$/, ''),
		},
	});
};

export {
	aiApiCall,
};
